import { useCafAnalysisComponentDetailV5 } from '../../../../../modules/apis/webview/caf'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { useLessonsStack } from '../../../../../pages/[lang]/webview/lessons'
import LoadingSpinner from '../../../../common/LoadingSpinner'
import ComplexityIntroSection from '../../../../new-portal/caf/analysis/complexity/ComplexityIntroSection'
import ComplexityTabsSection from '../../../../new-portal/caf/analysis/complexity/ComplexityTabsSection'
import ThickDivider from '../../../../new-portal/caf/common/ThickDivider'
import WebviewStackContainer from '../../../common/WebviewStackContainer'

const AIComplexityActivity = ({ params }) => {
  const { useLessonsFlow } = useLessonsStack()
  const { pop } = useLessonsFlow()
  const { lessonId, componentId } = params
  const { t } = useTranslation()
  const { isLoading } = useCafAnalysisComponentDetailV5(+componentId)

  return (
    <div>
      <WebviewStackContainer height="52px" onBack={pop} title={t(n_caf.overview.complexity)} border={true}>
        {isLoading ? (
          <div className="h-screen">
            <LoadingSpinner lg primary show />
          </div>
        ) : (
          <div className="keep-all min-h-screen break-words bg-white px-[20px] pt-[16px] pb-[40px] text-gray-700">
            <ComplexityIntroSection componentId={componentId} />
            <ThickDivider />
            <div className="h-24" />
            <ComplexityTabsSection componentId={componentId} />
            <div className="h-24" />
          </div>
        )}
      </WebviewStackContainer>
    </div>
  )
}

export default AIComplexityActivity
